import helpers from 'helpers'
import constants from 'constants/index'

const mountDataProcessSources = (
  dataProcessSources,
  departments,
  watchSourceDescription,
  isDefault = false,
) => {
  var items = isDefault ? dataProcessSources : []

  if (!isDefault) {
    if (watchSourceDescription === constants.dataProcess.DEPARTMENT_SOURCE) {
      items = [
        {
          entityId: constants.dataProcess.ADD_ALL_DEPARTMENTS,
          entityName: 'Todos os departamentos',
        },
        ...departments,
      ]
    } else {
      const formattedSource = helpers.dataProcess.convertSourceKind(
        watchSourceDescription,
      )
      items = dataProcessSources?.filter(
        (dataProcessSource) => dataProcessSource.kind === formattedSource,
      )
    }
  }

  return items.map((dpSource) => ({
    entityId: dpSource.entityId || dpSource.id,
    entityName: dpSource.entityName || dpSource.name,
  }))
}

export default mountDataProcessSources
